import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SRefundDetailsPageContentRow = styled.div`
  gap: 20px;

  ${setFlexDF};
`;
